import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Space, Tooltip } from 'antd';

import { StatusFile } from '@/utils/enum';
import { ACTION_ICON_SIZE } from '@/views/Bera/constants';
import { DownloadIcon, TrashIcon } from '@/assets/icons/v2';

import type { BeraTaskResultV2 } from '@/types/Bera';
import * as S from './styles';

interface ClipItemProps {
	task: BeraTaskResultV2;
	onDownload: (task: BeraTaskResultV2) => void;
	onDelete: (task: BeraTaskResultV2) => void;
}

export function ClipItem({ task, onDownload, onDelete }: Readonly<ClipItemProps>): JSX.Element {
	const isDownloadable = task.file?.status === StatusFile.PROCESSED && !!task.file?.url;
	const name = task.file?.original_name ?? task.name;

	function handleDownload() {
		onDownload(task);
	}

	function handleDelete() {
		onDelete(task);
	}

	return (
		<S.ClipRow span={24}>
			<Tooltip title={name}>
				<S.ClipName>{name}</S.ClipName>
			</Tooltip>
			<Space size="small">
				<Tooltip title={I18n.get('Download')}>
					<S.DownloadButton
						type="link"
						onClick={handleDownload}
						disabled={!isDownloadable}
						aria-label={I18n.get('Download')}
						icon={<DownloadIcon width={ACTION_ICON_SIZE} height={ACTION_ICON_SIZE} />}
					/>
				</Tooltip>
				<Tooltip title={I18n.get('Delete')}>
					<S.DangerButton
						type="link"
						onClick={handleDelete}
						aria-label={I18n.get('Delete')}
						icon={<TrashIcon width={ACTION_ICON_SIZE} height={ACTION_ICON_SIZE} />}
					/>
				</Tooltip>
			</Space>
		</S.ClipRow>
	);
}
